export const ONE_KB_IN_BYTES = 1024
export const ONE_MB_IN_BYTES = ONE_KB_IN_BYTES * 1024
export const ONE_GB_IN_BYTES = ONE_MB_IN_BYTES * 1024
export const ONE_TB_IN_BYTES = ONE_GB_IN_BYTES * 1024

export const MAX_IMAGE_UPLOAD_SIZE_MB = 24
export const MAX_IMAGE_UPLOAD_SIZE_BYTES = MAX_IMAGE_UPLOAD_SIZE_MB * ONE_MB_IN_BYTES
